import { render, staticRenderFns } from "./ProjectRoleRuleCreate.vue?vue&type=template&id=fc8a5a78&"
import script from "./ProjectRoleRuleCreate.vue?vue&type=script&lang=js&"
export * from "./ProjectRoleRuleCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports